import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { useAuthTokenContext } from '@/shared/context/AuthTokenContext.tsx';

/**
 * Sets the Sentry user from the authenticated token's `email` claim. Provider-agnostic:
 * it reads from AuthTokenContext, so it works on both the Okta and OAuth login paths.
 * Must be rendered inside an initialized AuthTokenContext (see AuthGuard's EnhancedOutlet).
 */
export const SentryUserProvider = () => {
    const { getTokenPayload } = useAuthTokenContext();
    const email = getTokenPayload().email;

    useEffect(() => {
        Sentry.setUser(email !== undefined ? { email } : null);
    }, [email]);

    return null;
};
